import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const buttonContainerStyle = css`
  display: flex;
  flex-direction: row-reverse;
  margin: ${theme.spacing(0, 3)};
  margin-top: ${theme.spacing(2)};
`;
